import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginLayout from '../layout/login';
import Dashboard from '../pages/admin/Dashboard';
import StudentAttendance from '../pages/admin/StudentAttendance';
import OjtVisits from '../pages/admin/OjtVisits';
import Instructors from '../pages/admin/Instructors';
import ProtectedRoute from "./ProtectedRoute";
import PreventAuthRoute from "./PreventAuthRoute"; // Import the new component
import TrainerDashboard from '../pages/trainer/Dashboard';
import UpdateProfileForm from 'src/layout/trainee/traineeProfile/updateProfile';
import TraineeDetails from 'src/layout/trainee/traineeProfile/details'
import NotFound from 'src/components/custom/NotFound';
import OjtAttendanceLayout from 'src/layout/iti/ojtAttendanceLayout';
import AttendanceHistoryLayout from 'src/layout/trainee/attendance';
import Mapping from '../pages/Mcc/Maping';
import Student from '../pages/Mcc/Student';
import Industry from '../pages/Mcc/Industry';
import Iti from '../pages/Mcc/Iti';
import Trade from "../pages/Mcc/Trade";
import Trainer from "../pages/Mcc/Trainer";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Login routes protected by PreventAuthRoute */}
      <Route path="/" element={<PreventAuthRoute><LoginLayout /></PreventAuthRoute>} />
      <Route path="/login" element={<LoginLayout />} />
      <Route path="/admin" element={<PreventAuthRoute><LoginLayout /></PreventAuthRoute>} />
      <Route path="/mcc" element={<PreventAuthRoute><LoginLayout /></PreventAuthRoute>} />
      {/* Admin Protected Routes */}
      <Route
        path="/admin/dashboard"
        element={<ProtectedRoute element={<Dashboard />} allowedRoles={['admin']} />}
      />
      <Route
        path="/admin/attendance"
        element={<ProtectedRoute element={<StudentAttendance />} allowedRoles={['admin']} />}
      />
      <Route
        path="/admin/ojt-visits"
        element={<ProtectedRoute element={<OjtVisits />} allowedRoles={['admin']} />}
      />
      <Route
        path="/admin/instructors"
        element={<ProtectedRoute element={<Instructors />} allowedRoles={['admin']} />}
      />
      

      {/* MCC (same shell as admin) */}
      <Route
        path="/mcc/mapping"
        element={<ProtectedRoute element={<Mapping />} allowedRoles={['mcc']} />}
      />

      <Route
        path="/mcc/student"
        element={<ProtectedRoute element={<Student />} allowedRoles={['mcc']} />} />

      <Route
        path="/mcc/industry"
        element={<ProtectedRoute element={<Industry />} allowedRoles={['mcc']} />}
      />
      <Route
        path="/mcc/iti"
        element={<ProtectedRoute element={<Iti />} allowedRoles={['mcc']} />}
      />
      <Route
        path="/mcc/trade"
        element={<ProtectedRoute element={<Trade />} allowedRoles={['mcc']} />}
      />
      <Route
        path="/mcc/trainer"
        element={<ProtectedRoute element={<Trainer />} allowedRoles={['mcc']} />}
      />

      {/* Trainee Protected Routes */}
      <Route path="/Trainee-details" element={<ProtectedRoute element={<TraineeDetails />} allowedRoles={['trainee']} />} />
      <Route path="/update-profile" element={<ProtectedRoute element={<UpdateProfileForm />} allowedRoles={['trainee']} />} />
      <Route path="/attendance-history" element={<ProtectedRoute element={<AttendanceHistoryLayout />} allowedRoles={['trainee']} />} />

      {/* ITI Protected Routes */}
      <Route path="/iti-home" element={<ProtectedRoute element={<OjtAttendanceLayout />} allowedRoles={['iti']} />} />

      {/* Trainer Protected Routes */}
      <Route path="/trainer/dashboard" element={<ProtectedRoute element={<TrainerDashboard />} allowedRoles={['trainer']} />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;